var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsReportScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2334 17H21.0776V21H7.2334V17Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 17H2.2334V21H6.2334V17Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 12H2.2334V16H6.2334V12Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2334 7H2.2334V11H6.2334V7Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8025 12C12.8735 13.173 14.378 13.8841 15.9901 13.9493L16.2421 13.9542C17.2059 13.9474 18.1547 13.7145 19.0121 13.2742L20.8621 15.1242C20.9287 15.2003 21.0009 15.2698 21.0776 15.3325V16H7.2334V12H11.8025ZM11.064 11H21.0776V7H10.3097C10.4126 6.36054 10.6198 5.73329 10.9321 5.1442H10.9621C11.2261 4.62264 11.5628 4.14117 11.9621 3.7142C14.0605 1.65835 17.3388 1.42414 19.7082 3.16082C22.0775 4.89751 22.841 8.0943 21.5121 10.7142L23.3621 12.5742L23.4021 12.5842C23.9074 13.0266 24.1243 13.7135 23.9649 14.3658C23.8054 15.0182 23.2961 15.5275 22.6437 15.687C22.0896 15.8224 21.5106 15.6863 21.0776 15.3325V12H11.8025C11.5386 11.711 11.301 11.3939 11.0946 11.0515C11.0843 11.0344 11.0741 11.0172 11.064 11ZM11.064 11C10.3442 9.77854 10.0905 8.36162 10.3097 7H7.2334V11H11.064Z",
    fill: "#3CDBC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.233398)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsReportScan);
export default __webpack_public_path__ + "static/media/icons_report_scan.a4b56982.svg";
export { ForwardRef as ReactComponent };